function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import find from 'lodash/find';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import groupBy from 'lodash/groupBy';
import sumBy from 'lodash/sumBy';
import reduce from 'lodash/reduce';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import round from 'lodash/round';
import join from 'lodash/join';
import union from 'lodash/union';
import isNumber from 'lodash/isNumber';
import isPlainObject from 'lodash/isPlainObject';
import mergeWith from 'lodash/mergeWith';
import partition from 'lodash/partition';
export const calculateActivities = (activities)=>activities.reduce((a, b)=>{
        const { value } = b;
        return a + (value || 0);
    }, 0);
export const calculateCarbs = (foods)=>foods ? foods.reduce((a, b)=>a + (b.nutritions ? b.nutritions.reduce((result, nextValue)=>result + (nextValue.unit === 2 ? (nextValue.value / 1000).toFixed(2) : parseFloat(nextValue.value.toFixed(2), 10) || 0), 0) : 0 || 0), 0) : 0;
export const calculateMedicationFastValue = (medications)=>medications.filter((item)=>item.name === 'Fast-acting Insulin').reduce((a, b)=>a + (b.value || 0), 0);
export const calculateMedicationLongValue = (medications)=>medications.filter((item)=>item.name === 'Long-acting Insulin').reduce((a, b)=>a + (b.value || 0), 0);
export const calculatePills = (medications)=>medications.filter((item)=>item.name !== 'Fast-acting Insulin' && item.name !== 'Long-acting Insulin');
export const calculateRelatedValue = (relatedData)=>{
    if (relatedData.activities && relatedData.foods && relatedData.medications) {
        const activityValue = calculateActivities(relatedData.activities);
        const foodValue = calculateCarbs(relatedData.foods);
        const medicationFastValue = calculateMedicationFastValue(relatedData.medications);
        const medicationLongValue = calculateMedicationLongValue(relatedData.medications);
        const pillsItems = calculatePills(relatedData.medications);
        return {
            activityValue,
            foodValue,
            medicationFastValue,
            medicationLongValue,
            pillsCount: pillsItems.length,
            pillsItems
        };
    }
    return {
        activityValue: 0,
        foodValue: 0,
        medicationFastValue: 0,
        medicationLongValue: 0,
        pillsCount: 0,
        pillsItems: []
    };
};
export const getUnitMedication = (medication)=>{
    switch(medication.unit){
        case 1:
            return 'injections';
        case 2:
            return 'pills';
        case 3:
            return 'milligrams';
        case 4:
            return 'units';
        default:
            return typeof medication.unit === 'string' ? medication.unit : 'none';
    }
};
export const toMedication = (medication)=>{
    const { value, name } = medication;
    return `${name}: ${value} ${getUnitMedication(medication)}`;
};
export const calculateMedications = (medications)=>medications.reduce((acc, medication)=>acc ? join([
            acc,
            toMedication(medication)
        ], ', ') : toMedication(medication), '');
export const calculateRelatedValueForBGDataReport = (relatedData)=>{
    if (relatedData.activities && relatedData.foods && relatedData.medications) {
        const activityValue = calculateActivities(relatedData.activities);
        const foodValue = calculateCarbs(relatedData.foods);
        const medications = calculateMedications(relatedData.medications);
        return {
            activityValue,
            foodValue,
            medications
        };
    }
    return {
        activityValue: 0,
        foodValue: 0,
        medications: ''
    };
};
export function getEndTimeTooltip(object, timestamp, index, pointMargins) {
    const arrayTimestamps = Object.keys(object);
    let { endTimestamp: endTooltip } = maxBy(object[timestamp], 'endTimestamp');
    if (arrayTimestamps.length - 1 > index) {
        const startNextObject = minBy(object[arrayTimestamps[index + 1]], 'deviceDateTime').deviceDateTime;
        if (startNextObject && startNextObject < endTooltip) {
            endTooltip = startNextObject;
        }
    }
    return Math.max(endTooltip - pointMargins, timestamp);
}
export function prepareMeasurements(measurements, type, metricConversions, firstTick, lastTick, pointMargins) {
    let array = measurements.map((measurement)=>({
            x: measurement.timestamp,
            y: metricConversions[type].toDisplay(measurement.value),
            measurement
        }));
    if (!array.find((measurement)=>measurement.timestamp === firstTick)) {
        array.push({
            x: firstTick,
            y: 0
        });
    }
    if (!array.find((measurement)=>measurement.timestamp === lastTick)) {
        array.push({
            x: lastTick,
            y: 0
        });
    }
    array = array.sort((a, b)=>a.x - b.x);
    array = array.map((data, index)=>{
        if (array.length - 1 > index) {
            data.xEnd = array[index + 1].x;
            data.yEnd = array[index + 1].y;
        }
        if (index === 0) {
            return data;
        }
        data.prevX = array[index - 1].x;
        data.prevY = array[index - 1].y;
        if (data.y <= 0) {
            data.y = array[index - 1].y;
        }
        return data;
    }).filter((measurement)=>measurement.x >= firstTick && measurement.x < lastTick);
    array.forEach((element, index)=>{
        if (array.length - 1 > index) {
            array.push(_object_spread_props(_object_spread({}, element), {
                x: Math.max(element.xEnd - pointMargins, element.x),
                y: element.yEnd || element.y,
                yStart: element.y,
                xStart: element.x
            }));
        }
    });
    array = array.sort((a, b)=>a.x - b.x);
    return array;
}
export function calculateRelatedData(relatedData, lastTick) {
    const daySeconds = 86400;
    const hourSeconds = 3600;
    const relatedDataGrouped = {
        medications: [],
        activities: []
    };
    relatedData.forEach((data)=>{
        const { activities, medications, deviceDateTime } = data;
        relatedDataGrouped.activities = relatedDataGrouped.activities.concat(activities.map((activity)=>{
            activity.deviceDateTime = deviceDateTime;
            let timeAfterRange = 0;
            if (activity.deviceDateTime + hourSeconds > lastTick) {
                timeAfterRange = activity.deviceDateTime + hourSeconds - lastTick;
            }
            activity.endTimestamp = deviceDateTime + hourSeconds - timeAfterRange;
            return activity;
        }));
        relatedDataGrouped.medications = relatedDataGrouped.medications.concat(medications.map((medication)=>{
            if (medication.name !== 'Long-acting Insulin' && medication.name !== 'Fast-acting Insulin') {
                return null;
            }
            medication.deviceDateTime = deviceDateTime;
            const extraTime = medication.name === 'Fast-acting Insulin' ? hourSeconds * 6 : daySeconds;
            let timeAfterRange = 0;
            if (medication.deviceDateTime + extraTime > lastTick) {
                timeAfterRange = medication.deviceDateTime + extraTime - lastTick;
            }
            medication.endTimestamp = deviceDateTime + extraTime - timeAfterRange;
            medication.endTooltip = medication.endTimestamp;
            return medication;
        })).filter((medication)=>medication);
    });
    return relatedDataGrouped;
}
export function translateMeal(meal) {
    const { nutritions } = meal;
    const grouped = groupBy(nutritions, 'type');
    return _object_spread_props(_object_spread({}, meal), {
        carbs: sumBy(get(grouped, 'Carbohydrates'), 'value'),
        fat: sumBy(get(grouped, 'FatTotal'), 'value'),
        protein: sumBy(get(grouped, 'Protein'), 'value'),
        energy: sumBy(get(grouped, 'Energy'), 'value'),
        type: 'food',
        isSnaqImport: true
    });
}
export function translateTimeSeriesResources(translatedTimeSeriesResources) {
    return filter(translatedTimeSeriesResources, {
        resourceType: 'Meal'
    });
}
export function translateRelatedDataIntoMeals(relatedData) {
    const result = [];
    forEach(relatedData, (data)=>{
        const { foods, deviceDateTime, dateTime } = data;
        if (!foods || !foods.length) {
            return;
        }
        const filteredFoods = [];
        forEach(foods, (food)=>{
            if (food.isDeleted) return;
            const carbs = get(find(food.nutritions, {
                type: 'Carbs'
            }), 'value', 0);
            filteredFoods.push(_object_spread_props(_object_spread({}, food), {
                carbs
            }));
        });
        if (!filteredFoods.length) {
            return;
        }
        // TODO: Remove aggregation if stacking is done
        const name = join(map(filteredFoods, 'name'), ', ');
        const carbs = round(reduce(filteredFoods, (acc, food)=>acc + food.carbs, 0));
        const mappedMeal = {
            id: filteredFoods[0],
            name,
            carbs,
            timestamp: deviceDateTime || dateTime,
            type: 'food',
            isSnaqImport: false
        };
        result.push(mappedMeal);
    });
    return result;
}
export function mergeDataIntoMeals(relatedData, translatedTimeSeriesResources) {
    return [
        ...translateRelatedDataIntoMeals(relatedData),
        ...translateTimeSeriesResources(translatedTimeSeriesResources)
    ];
}
export function translateMealsIntoChartData(meals, firstTick) {
    // empty ranges are needed to separate fulfilled chart area based on timestamp & meal component width & scale
    const emptyRanges = [
        {
            x: firstTick,
            y: 1
        }
    ];
    const sortedMeals = sortBy(meals, 'timestamp');
    forEach(sortedMeals, (meal)=>{
        const { timestamp } = meal;
        emptyRanges.push({
            // to be improved, random value - need to use xScale
            x: timestamp - 100000,
            y: 1
        });
    });
    return [
        {
            id: 'meals',
            data: map(meals, (meal)=>({
                    x: meal.timestamp,
                    y: 1,
                    meal
                }))
        },
        {
            id: 'meals-empty',
            data: emptyRanges
        }
    ];
}
export function translateReadingRelatedData(relatedData) {
    const translatedData = [];
    if (!relatedData) {
        return translatedData;
    }
    const { deviceDateTime, dateTime, foods } = relatedData;
    const timestamp = deviceDateTime || dateTime;
    const filteredFoods = [];
    let carbs = 0;
    if (foods && foods.length) {
        forEach(foods, (food)=>{
            const foundFood = find(food.nutritions, {
                type: 'Carbs'
            });
            if (food.isDeleted) return;
            carbs += get(foundFood, 'value', 0);
            filteredFoods.push(_object_spread_props(_object_spread({}, food), {
                carbs
            }));
        });
        if (filteredFoods.length) {
            const name = join(map(filteredFoods, 'name'), ', ');
            translatedData.push({
                timestamp,
                name,
                carbs,
                type: 'food'
            });
        }
    }
    forEach(relatedData.activities, (activity)=>{
        // TODO check for obsolete calculations. The expression below always returns 60 minutes
        // const { endTimestamp } = activity;
        // const duration = moment.duration(endTimestamp - deviceDateTime, 'seconds').asMinutes();
        translatedData.push(_object_spread_props(_object_spread({}, activity), {
            timestamp,
            duration: activity.value,
            type: 'activity'
        }));
    });
    const [injections, pills] = partition(relatedData.medications, (medication)=>medication.name === 'Fast-acting Insulin' || medication.name === 'Long-acting Insulin');
    forEach(injections, (injection)=>{
        translatedData.push(_object_spread_props(_object_spread({}, injection), {
            type: 'injection',
            timestamp
        }));
    });
    forEach(pills, (pill)=>{
        translatedData.push(_object_spread_props(_object_spread({}, pill), {
            type: 'pill',
            timestamp
        }));
    });
    return translatedData;
}
export function getUniqRelatedData(relatedData, translatedTimeSeriesResources) {
    return filter(relatedData, (rb)=>{
        const { timestamp, type, carbs } = rb;
        const tsr = find(translatedTimeSeriesResources, {
            timestamp,
            type,
            carbs
        });
        return !tsr;
    });
}
const aggregateRelatedValues = (relatedValues1, relatedValues2)=>{
    const result = {};
    const keys = union(Object.keys(relatedValues1), Object.keys(relatedValues2));
    keys.forEach((key)=>{
        const v1 = relatedValues1[key];
        const v2 = relatedValues2[key];
        switch(key){
            case 'foodValue':
                if (isNumber(v1) && isNumber(v2)) {
                    result[key] = v1 + v2;
                } else {
                    result[key] = v2 !== undefined ? v2 : v1;
                }
                break;
            case 'activity':
            case 'note':
                if (v1 && v2) {
                    result[key] = join([
                        v1,
                        v2
                    ], ', ');
                } else {
                    result[key] = v2 !== undefined ? v2 : v1;
                }
                break;
            default:
                result[key] = v2 !== undefined ? v2 : v1;
                break;
        }
    });
    return result;
};
export const aggregateGroupedRelatedValues = (groupedRelatedValues1, groupedRelatedValues2)=>mergeWith({}, groupedRelatedValues1, groupedRelatedValues2, (val1, val2)=>{
        if (isPlainObject(val1) && isPlainObject(val2)) {
            return aggregateRelatedValues(val1, val2);
        }
        return undefined;
    });
